import {update} from "lodash"
import {ModelTest, ResetRecoAreaData, TableObjData} from "../../util/interfaceData"
import {resetOcrTableData, resetRecoAreaData} from "../resetData"

export function modelTestInit() {
    return {type: "modelTestInit", payload: {}}
}
export function classiferInit(data: any) {
    return {type: "classiferInit", payload: data}
}
export function classiferUpdateData(data: any) {
    return {type: "classiferUpdate", payload: data.operate_test}
}
export function modelTestUpdate(updateData: ModelTest) {
    if (updateData.hasOwnProperty("loading") && updateData.loading !== null) {
        return {type: "loading", payload: "loading"}
    } else if (updateData.hasOwnProperty("stopLoading") && updateData.stopLoading !== null) {
        return {type: "stopLoading", payload: "stopLoading"}
    } else {
        return createData(updateData)
    }
}

export function createData(updateData: any) {
    let recognitionArea: ResetRecoAreaData = {
        recognitionArea: [],
        errorField: [],
    }
    let tableData: Array<TableObjData> = []
    if ("recognitionArea" in updateData.ocrData.ocrResult) {
        recognitionArea = resetRecoAreaData(updateData.ocrData.ocrResult.recognitionArea)
    }
    if (
        "table" in updateData.ocrData.ocrResult &&
        "tableField" in updateData.ocrData.ocrResult &&
        updateData.ocrData.ocrResult["table"] !== null
    ) {
        // tableData = resetOcrTableData(updateData.ocrData.ocrResult.table, updateData.tableField)
        tableData = resetOcrTableData(updateData.ocrData.ocrResult.table, updateData.ocrData.ocrResult.tableField)
    }
    return {
        type: "modelTestUpdate",
        payload: {
            ...recognitionArea,
            status: updateData.ocrData.ocrResult.status,
            templateName: updateData.ocrData.ocrResult.templateName,
            // markdownName: updateData.markdownName,
            // jsonData: updateData.jsonData ? updateData.jsonData : {},
            table: tableData,
        },
    }
}

// eslint-disable-next-line no-shadow
export function errorMessage(errorMessage: string) {
    return {type: "error", payload: errorMessage}
}
